import { Operation } from './Transactions.types';

export const MOCK_OPERATIONS: Operation[] = [
  {
    id: '57999131',
    operationNumber: '57999131',
    serviceName: 'Премиум 15 дней',
    amount: 24,
    paymentMethod: 'Банковская карта',
    date: '30.01.2026, 03:00',
    direction: 'expense',
  },
  {
    id: '57999132',
    operationNumber: '57999132',
    serviceName: 'Поднять 15 раз',
    amount: 3,
    paymentMethod: 'Сохраненная карта',
    date: '30.01.2026, 03:00',
    direction: 'expense',
    ad: {
      id: '123',
      title: 'Настольные компьютеры и комплектующие',
      path: '/elanlar/nastolnye-kompyutery-i-komplektuyushchie-123',
    },
  },
  {
    id: '57999133',
    operationNumber: '57999133',
    serviceName: 'Настольные компьютеры...',
    amount: 5,
    paymentMethod: 'Личный счет',
    date: '30.01.2026, 03:00',
    direction: 'expense',
  },
  {
    id: '57999134',
    operationNumber: '57999134',
    serviceName: 'Пополнение счета',
    amount: 2000,
    paymentMethod: 'Банковская карта',
    date: '30.01.2026, 03:00',
    direction: 'income',
  },
  {
    id: '57999135',
    operationNumber: '57999135',
    serviceName: 'Возврат на карту',
    amount: 20,
    paymentMethod: 'Банковская карта',
    date: '30.01.2026, 03:00',
    direction: 'income',
  },
  {
    id: '57999136',
    operationNumber: '57999136',
    serviceName: 'VIP 15 дней',
    amount: 3,
    paymentMethod: 'Yigim',
    date: '30.01.2026, 03:00',
    direction: 'expense',
  },
  {
    id: '57999137',
    operationNumber: '57999137',
    serviceName: 'Премиум',
    amount: 3,
    paymentMethod: 'Million',
    date: '30.01.2026, 03:00',
    direction: 'expense',
  },
  {
    id: '57999138',
    operationNumber: '57999138',
    serviceName: 'Премиум',
    amount: 3,
    paymentMethod: 'Банковская карта',
    date: '30.01.2026, 03:00',
    direction: 'expense',
  },
];
